<template>
  <div class="content">
    <h2>戦闘開始！</h2>
  </div>
</template>

<script>
export default {
  name:'battle-start',
  props:{
    options: Object
  }
}
</script>

<style lang="scss" scoped>
.content {
  background-color: #FFF;
  margin: 2px 1px;
  padding: 10px;
}
</style>
